export const FETCH_SUPPORT_SECTION_DETAIL_REQUEST =
  "FETCH_SUPPORT_SECTION_DETAIL_REQUEST";
export const FETCH_SUPPORT_SECTION_DETAIL_RECEIVE =
  "FETCH_SUPPORT_SECTION_DETAIL_RECEIVE";
export const FETCH_SUPPORT_SECTION_DETAIL_FAILURE =
  "FETCH_SUPPORT_SECTION_DETAIL_FAILURE";

export const FETCH_SUPPORT_ARTICLE_DETAIL_REQUEST =
  "FETCH_SUPPORT_ARTICLE_DETAIL_REQUEST";
export const FETCH_SUPPORT_ARTICLE_DETAIL_RECEIVE =
  "FETCH_SUPPORT_ARTICLE_DETAIL_RECEIVE";
export const FETCH_SUPPORT_ARTICLE_DETAIL_FAILURE =
  "FETCH_SUPPORT_ARTICLE_DETAIL_FAILURE";

export const STORE_SUPPORT_SEARCH_QUERY = "STORE_SUPPORT_SEARCH_QUERY";
export const RESET_SECTION_DETAIL_DATA = "RESET_SECTION_DETAIL_DATA";
export const RESET_ARTICLE_DETAIL_DATA = "RESET_ARTICLE_DETAIL_DATA";

export const NEW_SEARCH_SUPPORT_ARTICLES_REQUEST =
  "NEW_SEARCH_SUPPORT_ARTICLES_REQUEST";
export const NEW_SEARCH_SUPPORT_ARTICLES_RECEIVE =
  "NEW_SEARCH_SUPPORT_ARTICLES_RECEIVE";
export const NEW_SEARCH_SUPPORT_ARTICLES_FAILURE =
  "NEW_SEARCH_SUPPORT_ARTICLES_FAILURE";

export const FETCH_ALL_SUPPORT_DATA_REQUEST = "FETCH_ALL_SUPPORT_DATA_REQUEST";
export const FETCH_ALL_SUPPORT_DATA_RECEIVE = "FETCH_ALL_SUPPORT_DATA_RECEIVE";
export const FETCH_ALL_SUPPORT_DATA_FAILURE = "FETCH_ALL_SUPPORT_DATA_FAILURE";

const Support = {
  FETCH_SUPPORT_SECTION_DETAIL_REQUEST,
  FETCH_SUPPORT_SECTION_DETAIL_RECEIVE,
  FETCH_SUPPORT_SECTION_DETAIL_FAILURE,
  FETCH_SUPPORT_ARTICLE_DETAIL_REQUEST,
  FETCH_SUPPORT_ARTICLE_DETAIL_RECEIVE,
  FETCH_SUPPORT_ARTICLE_DETAIL_FAILURE,
  STORE_SUPPORT_SEARCH_QUERY,
  RESET_SECTION_DETAIL_DATA,
  RESET_ARTICLE_DETAIL_DATA,
  NEW_SEARCH_SUPPORT_ARTICLES_REQUEST,
  NEW_SEARCH_SUPPORT_ARTICLES_RECEIVE,
  NEW_SEARCH_SUPPORT_ARTICLES_FAILURE,
  FETCH_ALL_SUPPORT_DATA_REQUEST,
  FETCH_ALL_SUPPORT_DATA_RECEIVE,
  FETCH_ALL_SUPPORT_DATA_FAILURE,
};

export default Support;
